import { externalRoutes, routes } from '@routes';

interface ILink {
  name: string;
  path: string;
  subpages?: string[];
  external?: boolean;
}

interface ISubLink extends ILink {
  description: string;
}

export interface IMainLink extends ILink {
  submenu?: ISubLink[];
  mainPath?: string;
}

export const links: IMainLink[] = [
  {
    name: 'Products',
    path: routes.products,
    submenu: [
      {
        name: 'Content Delivery & Network Services',
        description: 'Deliver exceptional performance at scale',
        path: routes.productContentDeliveryAndNetworkServices,
      },
      {
        name: 'Cloud Computing',
        description: 'Build, scale, and run modern workloads',
        path: routes.productCloudComputing,
      },
      {
        name: 'Media Processing Services',
        description: 'Streamline your video pipeline',
        path: routes.productMediaProcessingServices,
      },
      {
        name: 'Security',
        description: 'Protect apps and content from threats',
        path: routes.productSecurity,
      },
    ],
  },
  { name: 'Network', path: routes.network },
  {
    name: 'Pricing',
    path: routes.pricing,
  },
  {
    name: 'Company',
    path: routes.aboutUs,
    submenu: [
      {
        name: 'About CDN77',
        description: 'Find out more about our company and values that drive us',
        path: routes.aboutUs,
      },
      {
        name: 'Contact',
        description: 'Get in touch with our tech support or Client Solutions team',
        path: routes.contact,
      },
      {
        name: 'Meet our clients',
        description: 'What clients are saying about us',
        path: routes.reviews,
      },
    ],
  },
  {
    name: 'Documentation',
    path: externalRoutes.client.support,
    external: true,
  },
];
